import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppStore } from "../../../hooks/useStores";
import ConfirmationPopup from "../../common/ConfirmationPopup/ConfirmationPopup";
import styles from "./RequestAccessPopup.module.scss";

export type RequestAccessPopupProps = {
	children?: ReactNode;
	requestFeature: string;
	requestTitle: string;
	requestMessage: string;
	submissionMessage?: string;
	className?: string;
	paperClass?: string;
	confirmButtonText: string;
};

const RequestAccessPopup = ({
	children,
	requestFeature,
	requestTitle,
	requestMessage,
	submissionMessage,
	paperClass,
	confirmButtonText,
}: RequestAccessPopupProps) => {
	const { t } = useTranslation("translation", { keyPrefix: "requestAccessPopup" });
	const { appStore, uiStore } = useAppStore();
	const [openSuccessEmail, setOpenSuccessEmail] = useState(false);
	return (
		<>
			<ConfirmationPopup
				onClose={() => {
					uiStore.openCommonRequestAccessPopup = false;
				}}
				title={requestTitle}
				description={requestMessage}
				confirmButtonText={confirmButtonText}
				hideCancel={true}
				open={uiStore.openCommonRequestAccessPopup}
				onClick={async () => {
					const data = {
						requestFeature: requestFeature,
					};
					const response = await appStore.sendCommonRequestAccess(data);
					if (response) {
						setOpenSuccessEmail(true);
					}
					uiStore.openCommonRequestAccessPopup = false;
				}}
				paperClassName={clsx(styles.requestAccessCustomPaperClass, paperClass)}
				loading={appStore.isSendRequestAccessLoading}
			>
				{children && <>{children}</>}
			</ConfirmationPopup>
			<ConfirmationPopup
				onClose={() => setOpenSuccessEmail(false)}
				title={t("successRequestAccess.title")}
				description={submissionMessage ? submissionMessage : t("successRequestAccess.description")}
				confirmButtonText={t("successRequestAccess.primaryButton")}
				open={openSuccessEmail}
				onClick={async () => setOpenSuccessEmail(false)}
				hideCancel={true}
				paperClassName={styles.customPaperClass}
			/>
		</>
	);
};

export default observer(RequestAccessPopup);
